import React, { useEffect } from 'react';
import cookieStore from 'js-cookie';
import axios from 'axios';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ReactComponent as LeftArrow } from '../../assets/img/left-arrow.svg';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { setClaimDetails } from '../../store/actions/claimListActions';
import MemberDetailsCard from '../MemberDetailsCard';
import HeaderCard from '../HeaderCard';
import TreatmentDetailsCard from '../TreatmentDetailsCard';
import BillDetailsCard from '../BillDetailsCard';

function ClaimDetails() {
  const history = useHistory();
  const dispatch = useDispatch();
  const {payerId, providerId, hospActionId, payerClaimNo, providerName } =
    useSelector((state: RootState) => state.claimsDetailsInitialState);
    const claimDetails: any = useSelector(
        (state: RootState) => state?.claimsDetails?.claimDetails,
      );
  useEffect(() => {
    fetchDetails();
  }, []);

  const fetchDetails = () => {
    // const data: any = localStorage.getItem('data');
    // const jsonData = data?.length > 0 ? JSON.parse(data) : {};
    const accessToken = cookieStore.get('accessToken') || '';
    const actionId = hospActionId;
    const sendData: any = {
        payerId,
        providerId,
        actionId,
        payerClaimNo,
        providerName,
    };
    const requestOptions = {
      headers: { 'Content-Type': 'application/json', accesstoken: accessToken },
    };
    axios.post(
      `${process.env.REACT_APP_API_BASE_URL}Provider/Search/ClaimDetail`,
      sendData,
      requestOptions,
    ).then((result: any) => {
        // tslint:disable-next-line:no-shadowed-variable
        const claimDetails = result?.data?.claimDetails || {};
        dispatch(setClaimDetails(claimDetails));
    });
  };

  const handleGoBack = () => {
    history.goBack();
  };
  const logoutHandler = () => {
    cookieStore.remove('accessToken');
    history.replace('/');
  };
  return (
    <div>
      <div
        style={{ backgroundColor: '#4745DC', height: '40px', display: 'flex', alignItems: 'center' }}
      >
        <ArrowLeftOutlined
          rev={''}
          style={{ color: '#fff', fontSize: '25px', marginLeft: '10px' }}
          onClick={handleGoBack}
        />
        <span style={{marginLeft: '10px', fontSize: '1.5rem', color: '#fff'}}>{claimDetails?.patientName}</span>
      </div>
      <div>
        <button onClick={logoutHandler} className="logout-btn">
          <LeftArrow className="logout-arrow" />
          &nbsp;&nbsp; Logout
        </button>
      </div>
      <br/>
      <HeaderCard/>
      <br/>
      <MemberDetailsCard/>
      <br/>
      <TreatmentDetailsCard/>
      <br/>
      <BillDetailsCard/>
    </div>
  );
}

export default ClaimDetails;
